<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent != null && localService.languageContent.section_config_popup != undefined">
  <app-popup-header title="{{localService.languageContent.section_config_popup.title}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-3">{{localService.languageContent.section_config_popup.code}}</div>
      <div [ngClass]="wrapper.content.v1 == '' ? 'col-9' : 'col-9 en'">
        <input autocomplete="off" type="text" [(ngModel)]="wrapper.content.v1" placeholder="{{localService.languageContent.section_config_popup.code}}" title="{{localService.languageContent.section_config_popup.code}}" />
      </div>
    </div>
    <app-language-container [(languageContents)]="wrapper.languageContents"  [IsNeedNewLine]="true" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsShowAllLanguages]="true" [IsAllMandatory]="true"></app-language-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
